import Home from './Home'
import { connect } from 'react-redux'


const mapStateToProps = (state) => ({
    title: state.home.title,
})


export default connect(mapStateToProps)(Home)